import { FileInput, NumberInput, Paper, Stack, Text, Title } from '@mantine/core';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Sync } from '@/module/Sync/Sync';
import { useBibtexImportResult } from '@/module/Sync/model/SyncQuery';
import { ImportResult } from '@/module/Sync/model/SyncTypes';

import { PendingSpinner } from '@/core/components';

import { useAppNotification } from '@feature/utils';

export function SyncBibtex() {
  const { t } = useTranslation();
  const [result, setResult] = useState<ImportResult | null>(null);
  const [yearStr, setYearStr] = useState<string | number>('2023');

  const year = yearStr == null || yearStr === '' ? 2023 : Number(yearStr);

  const { mutate, isPending } = useBibtexImportResult();
  const notification = useAppNotification();
  const onFileSet = (file: File | null) => {
    if (file == null) return;

    mutate(
      { year: year, file },
      {
        onSuccess: setResult,
        onError: notification.error,
      },
    );
  };

  if (isPending) {
    return <PendingSpinner />;
  }

  return (
    <Stack p="md">
      <Title>{t('sync.bibtex.title')}</Title>
      <Text
        c="dimmed"
        size="sm"
        fs="italic"
      >
        {t('sync.bibtex.meta')}
      </Text>

      {result == null && (
        <Paper p="md">
          <Stack>
            <NumberInput
              value={year}
              onChange={setYearStr}
              label={t('sync.bibtex.year')}
              placeholder={t('sync.bibtex.year')}
            />
            <FileInput
              onChange={onFileSet}
              label={t('sync.bibtex.file')}
              placeholder={t('sync.bibtex.filePlaceholder')}
            />
          </Stack>
        </Paper>
      )}
      {result != null && (
        <Sync
          sourceType="BIBTEX"
          result={result}
        />
      )}
    </Stack>
  );
}
